import { CardBasic } from "@/components/ui-library-new/card/CardBasic"
import { IconCircle } from "@/components/ui-library-new/icon/IconCircle"
import { BlokProps } from "@/helpers/StoryblokHelpers"
import { StepsSectionStoryblok } from "@/types/component-types"
import { cn } from "@/utils/utils"
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc"

export const StepsSection = ({ blok }: BlokProps<StepsSectionStoryblok>) => {
  const { title, items } = blok

  return (
    <section
      {...storyblokEditable(blok as SbBlokData)}
      className="flex flex-col gap-6 bg-surface py-[18px] lg:gap-8 lg:py-10"
    >
      <div className="mx-auto w-full max-w-[1155px] scroll-mt-32 px-4 lg:px-8">
        <h2 className="mb-8 text-[18px] font-extrabold text-neutral-90 lg:text-2xl">{title}</h2>
        <CardBasic className="min-h-[280px] rounded-2xl px-4 py-6">
          {/* Mobile: stacked list with dividers. Desktop: N equal columns via grid —
              grid-flow-col + auto-cols-fr make every child an equal 1fr column for any count.
              (Note: this repo's `flex-1` is a custom 12-col fraction, not flex-grow, so grid is used here.) */}
          <div className="flex flex-col divide-y divide-gray-200 lg:grid lg:auto-cols-fr lg:grid-flow-col lg:gap-8 lg:divide-y-0 lg:text-center">
            {items &&
              items.length > 0 &&
              items.map((item, index) => (
                <div
                  key={item._uid}
                  className={cn(
                    // Mobile: icon alternates sides (index 0 = left, per Figma). Desktop: always column.
                    "flex items-center gap-4 py-5 first:pt-0 last:pb-0 lg:flex-col lg:items-center lg:py-0",
                    index % 2 === 0 ? "flex-row" : "flex-row-reverse"
                  )}
                >
                  {/* A name goes to IconCircle's own DoktorIcon; the step number is the fallback
                      when the CMS icon field is left unset. */}
                  <IconCircle
                    icon={item.icon || <span className="text-2xl font-bold lg:text-3xl">{index + 1}</span>}
                    iconClassName="text-primary-50"
                    className="h-16 w-16 bg-primary-05 2xl:h-20 2xl:w-20"
                  />
                  <div className="flex flex-col gap-1 text-left lg:w-full lg:text-center">
                    <h2 className="my-0 text-[15px] font-bold text-neutral-90 lg:text-lg">{item.title}</h2>
                    <p className="text-sm tracking-normal text-neutral-50 lg:text-base">{item.description}</p>
                  </div>
                </div>
              ))}
          </div>
        </CardBasic>
      </div>
    </section>
  )
}
